import { Paragraph } from '@zillow/constellation-10';
import { useApplicationListing } from '../../../../../contexts/ApplicationContext';
import { ContactCard } from './ContactCard';

export function EmergencyContactSection() {
  const { listingOwner } = useApplicationListing();
  const landlordName = listingOwner?.name?.trim() || 'The landlord';

  return (
    <>
      <Paragraph textStyle="body-sm" css={{ marginBottom: 'default' }}>
        {`${landlordName} may reach this person if they can't contact you.`}
      </Paragraph>
      <ContactCard fieldName="emergencyContact" title="Emergency contact" hasRelationship />
    </>
  );
}
